import { gsap, TweenLite, Power1 } from "gsap";

document.addEventListener('DOMContentLoaded',function() {

    const el = document.querySelectorAll("[data-showmore]");

    const init = function() {

        const action = function(e) {
        	e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        	
            let target = e.currentTarget.dataset.showmore,
                obj = document.getElementById( target.slice(1, target.length) );
            
            if (obj.classList.contains('is-visible')) {
                TweenLite.to(obj, 0.4, {
                    height: 0,
                    opacity: 0
                })

                obj.classList.remove('is-visible');
                e.currentTarget.innerHTML = e.currentTarget.dataset.more;

            } else {
                TweenLite.set(obj, { 
                    height: "auto",
                    opacity: 1
                })

                TweenLite.from(obj, 0.4, {
                    height: 0,
                    opacity: 0
                })

                obj.classList.add('is-visible');
                e.currentTarget.innerHTML = e.currentTarget.dataset.less;
                
                //console.log(e.currentTarget.dataset.more);
            }
        };

        for (let i = 0; i < el.length; i++) {
            el[i].dataset.more = el[i].innerHTML;
            el[i].addEventListener('click', action);
        }
    }
    
    el.length >  0 ? init() : false;
    
}, false);
